import { z } from "zod";
import { AuthDTO } from "unnamed-contracts";

/**
 * Session type derived from shared contracts
 * Use with runtime validation via AuthDTO.SessionResponse.parse in dev
 */
export type Session = z.infer<typeof AuthDTO.SessionResponse>;
export type SessionProject = z.infer<typeof AuthDTO.SessionProject>;

export const SessionSchema = AuthDTO.SessionResponse;
export const SessionProjectSchema = AuthDTO.SessionProject;

